/**
 * Vehicle fuel tank capacity unit values
 */
export enum VehicleFuelTankCapacityUnitEnum {
	LITRE = 'litre',
	GALLON = 'gallon',
}
